// extracted by mini-css-extract-plugin
module.exports = {"myKitViewWrapper":"PressKit_view_myKitViewWrapper__C8NbS"};